import React, { useState } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import config from '../../config';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  Button,
  Form,
  FieldCurrencyInput,
  FieldCheckbox,
  FieldCheckboxGroup,
  FieldTextInput,
  FieldLanguagesKnown,
  InlineTextButton,
} from '../../components';
import css from './EditListingInstructionsForm.module.css';
import { groomingPresetsOptions, jobInstrucionOptions } from '../../marketplace-custom-config';
import arrayMutators from 'final-form-arrays';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
const textfield = 'textfield';
const errorTextField = 'errorTextField';
import { BsCheckLg } from 'react-icons/bs';

import { BsPlusLg } from 'react-icons/bs';

const isInvalidLanuage = (isRequired, languages) => {
  if (isRequired && !languages) return true;
  else if (!languages) return false;
  const valid = languages.every(lang => lang?.language !== null && lang?.minimumLevel !== null);
  return !valid;
};

export const EditListingInstructionsForm = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      // console.log(20, props);
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        form,
        errors,
        values,
        userNativeLang,
        history,
        currentListing,
      } = formRenderProps;

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = currentListing?.attributes?.publicData?.isCloneType
        ? false
        : invalid ||
          disabled ||
          submitInProgress ||
          isInvalidLanuage(false, values?.languageRequirements);
      //   || pristine
      // !!(values.languageRequirements?.[0].language === null) ||
      // !!(values.languageRequirements?.[0].minimumLevel === null) ||
      // values?.languageRequirements?.filter(f => f?.language === null).length > 0 ||
      // values?.languageRequirements?.filter(f => f.minimumLevel === null).length > 0;
      // console.log(
      //   77788,
      //   submitDisabled,
      //   values?.languageRequirements?.filter(f => f?.language === null) ,
      //     values?.languageRequirements?.filter(f => f.minimumLevel === null)
      // );
      const { updateListingError, showListingsError } = fetchErrors || {};

      const groomingRestrictionsPlaceholder = intl.formatMessage({
        id: 'EditListingInstructionForm.GroomingRestrictionsPlaceholder',
      });
      const languageLabel = intl.formatMessage({ id: 'EditListingInstructionsForm.languageLabel' });
      const minLevelLabel = intl.formatMessage({ id: 'EditListingInstructionsForm.minLevelLabel' });

      //for new job requirements

      // const [jobInstructionArray, setJobInstructionArray] = useState(jobInstrucionOptions);

      const { newJobInstructionArray = [] } = values;

      const jobInstructionArray = [...jobInstrucionOptions, ...newJobInstructionArray];

      const engTextPlaceholder = intl.formatMessage({
        id: 'EditListingInstructionForm.engTextPlaceholder',
      });

      const frTextPlaceholder = intl.formatMessage({
        id: 'EditListingInstructionForm.frTextPlaceholder',
      });

      const [showNewJobInstructionField, setShowNewJobInstructionField] = useState(false);
      const [EditMode, setEditMode] = useState(false);

      const addMoreJobInstructions = e => {
        setShowNewJobInstructionField(true);
      };

      const handleDelete = value => {
        // console.log(222, value);
        const { option } = value;
        const updatedArray = newJobInstructionArray.filter(item => item.key !== option.key);

        form.change('newJobInstructionArray', [...updatedArray]);
      };
      // console.log(212, values, jobInstructionArray);

      // const handleEdit = value => {
      //   const { fields, fieldId } = value;
      //   const name = fieldId.split('.')?.[1];
      //   const target = newJobInstructionArray.find(f => {
      //    return f.key===name
      //   })
      //   form.change('editJobInstructionEn',target.label.en);
      //   form.change('editJobInstructionFr', target.label.fr);
      //   console.log(667, value, name, target);
      //   setEditMode(true);
      // };
      return (
        <Form onSubmit={handleSubmit} className={classes}>
          {updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPricingForm.updateFailed" />
            </p>
          ) : null}
          {showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPricingForm.showListingFailed" />
            </p>
          ) : null}
          <div className={css.subHeadingContainer}>
            <div className={css.RiskHeading}>
              <FormattedMessage id="EditListingInstructionsForm.jobInstructionLabel" />
            </div>
          </div>
          <div>
            <FieldCheckboxGroup
              // className={css.features}
              // selectedClassName={css.customSelectedCheckbox}
              // className={css.customCheckbox}
              selectedValuesArray={values?.jobInstruction}
              id="jobInstruction"
              key={'jobInstruction'}
              name={'jobInstruction'}
              options={jobInstructionArray}
              userNativeLang={userNativeLang}
              fromEditListing={true}
              form={form}
              handleDelete={handleDelete}
              // handleEdit={handleEdit}
              // showTooltip={true}
              // validate={composeValidators(required(RequiredMessage))}
            />
            {/* {jobInstructionArray.length > 5 && jobInstructionArray.map((m, indx) => {
             return  indx>4?(<>Editt</>):null
            })  } */}
            {/* {EditMode ? (
              <div className={css.newInstructionDiv}>
                <div>
                  <span className={css.checkboxWrapper}>
                     <span className={css.iconWrapper}>
                     </span>
                  </span>

                  <FieldTextInput
                    className={textfield}
                    id="editJobInstructionEn"
                    name="editJobInstructionEn"
                    type="text"
                    placeholder={engTextPlaceholder}
                    // validate={composeValidators(required(descriptionRequiredMessage))}
                  />
                  <FieldTextInput
                    className={textfield}
                    id="editJobInstructionFr"
                    name="editJobInstructionFr"
                    type="text"
                    placeholder={frTextPlaceholder}
                    // validate={composeValidators(required(descriptionRequiredMessage))}
                  />
                </div>

                <div className={css.btnDiv}>
                  <InlineTextButton
                    type="button"
                    className={css.addMoreJobBtn}
                    // disabled={addBtnDisabled}
                    onClick={() => {
                      const newEditInstruction = {
                        key: values.editJobInstructionEn.replace(/\W+/g, ''),
                        value: values.editJobInstructionEn.replace(/\W+/g, ''),
                        label: {
                          en: values.editJobInstructionEn,
                          fr: values.editJobInstructionFr,
                        },
                      };
                      console.log(636, newEditInstruction);
                                            
                      form.change('newJobInstructionArray', [
                         ...newEditInstruction,
                      ]);
                     }}
                  >
             
                    <FormattedMessage id="WorkerExpForm.submitBtn" />
                     
                  </InlineTextButton>

                  <button
                    type="button"
                    onClick={() => {
                      setEditMode(false);
               
                    }}
                  >
                    <FormattedMessage id="SignupForm.Cancel" />
                  </button>
                </div>
              </div>
            ) : null} */}

            {showNewJobInstructionField ? (
              <div className={css.newInstructionDiv}>
                <div>
                  <span className={css.checkboxWrapper}>
                    {/*<IconCheckbox className={svgClassName} {...successColorVariantMaybe} />*/}
                    <span className={css.iconWrapper}>
                      {/* <BsCheckLg className={css.icon} /> */}
                    </span>
                  </span>

                  <FieldTextInput
                    className={textfield}
                    id="newJobInstructionEn"
                    name="newJobInstructionEn"
                    type="text"
                    placeholder={engTextPlaceholder}
                    // validate={composeValidators(required(descriptionRequiredMessage))}
                  />
                  <FieldTextInput
                    className={textfield}
                    id="newJobInstructionFr"
                    name="newJobInstructionFr"
                    type="text"
                    placeholder={frTextPlaceholder}
                    // validate={composeValidators(required(descriptionRequiredMessage))}
                  />
                </div>
                {/* {console.log(
                  777,

                  values?.newJobInstructionEn?.trim() === '' ||
                    values?.newJobInstructionFr?.trim() === '' ||
                    values?.newJobInstructionEn === undefined ||
                    values?.newJobInstructionFr === undefined
                )} */}

                <div className={css.btnDiv}>
                  <InlineTextButton
                    type="button"
                    className={css.addMoreJobBtn}
                    disabled={
                      values?.newJobInstructionEn?.trim() === '' ||
                      values?.newJobInstructionFr?.trim() === '' ||
                      values?.newJobInstructionEn === undefined ||
                      values?.newJobInstructionFr === undefined
                    }
                    onClick={() => {
                      const newInstruction = {
                        key: values.newJobInstructionEn.replace(/\W+/g, ''),
                        value: values.newJobInstructionEn.replace(/\W+/g, ''),
                        label: {
                          en: values.newJobInstructionEn,
                          fr: values.newJobInstructionFr,
                        },
                      };
                      // console.log(636, newInstruction);
                      setShowNewJobInstructionField(false);

                      form.change('newJobInstructionEn', '');
                      form.change('newJobInstructionFr', '');
                      form.change('newJobInstructionArray', [
                        ...newJobInstructionArray,
                        newInstruction,
                      ]);
                      // setJobInstructionArray(state => [...state, newInstruction]);
                    }}
                  >
                    {/* <span className={css.text}> */}
                    <FormattedMessage id="WorkerExpForm.submitBtn" />
                    {/* </span> */}
                  </InlineTextButton>

                  <button
                    type="button"
                    onClick={() => {
                      setShowNewJobInstructionField(false);
                      form.change('newJobInstructionEn', '');
                      form.change('newJobInstructionFr', '');
                    }}
                  >
                    <FormattedMessage id="SignupForm.Cancel" />
                  </button>
                </div>
              </div>
            ) : null}
            <InlineTextButton
              type="button"
              className={css.addMoreJobBtn}
              // disabled={addBtnDisabled}
              onClick={addMoreJobInstructions}
            >
              <BsPlusLg className={css.icon} />
              <span className={css.text}>
                <FormattedMessage id="EditListingInstructionsForm.AddInstructionText" />
              </span>
            </InlineTextButton>
          </div>
          {/* <div>
            <FieldCheckboxGroup
              // className={css.features}
              label={<FormattedMessage id="EditListingInstructionForm.GroomingPresetsLabel" />}
              selectedClassName={css.customSelectedCheckbox}
              className={css.customCheckbox}
              selectedValuesArray={values?.groomingPresets ? values?.groomingPresets : []}
              id="groomingPresets"
              key={`groomingPresets`}
              name={`groomingPresets`}
              options={groomingPresetsOptions}
              userNativeLang={userNativeLang}
              // validate={composeValidators(required(RequiredMessage))}
            />
          </div> */}

          <div className={css.fieldDiv}>
            <FieldTextInput
              className={textfield}
              id="groomingRestrictions"
              name="groomingRestrictions"
              // className={css.description}
              type="textarea"
              label={<FormattedMessage id="EditListingInstructionForm.GroomingRestrictionsLabel" />}
              placeholder={groomingRestrictionsPlaceholder}
              // validate={composeValidators(required(descriptionRequiredMessage))}
            />
          </div>
          <div className={css.sectionContainer}>
            <FieldLanguagesKnown
              formApi={form}
              id={'languageRequirements'}
              name="languageRequirements"
              userNativeLang={userNativeLang}
              titleClassName={css.workerJobCategoryTitle}
              values={values}
              isRequired={false}
              intl={intl}
              from={true}
              languageLabel={languageLabel}
              minLevelLabel={minLevelLabel}
            />
          </div>
          <div className={css.ButtonContainer}>
            <Button
              className={css.submitButton}
              type="submit"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </Button>
            <InlineTextButton
              type="button"
              className={css.cancelBtn}
              onClick={() => {
                // form.reset;
                history.replace(
                  createResourceLocatorString('ManageListingsPage', routeConfiguration())
                );
              }}
            >
              <FormattedMessage id="SignupForm.Cancel" />
            </InlineTextButton>
          </div>
        </Form>
      );
    }}
  />
);

EditListingInstructionsForm.defaultProps = { fetchErrors: null };

EditListingInstructionsForm.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(EditListingInstructionsForm);
